import { useCallback, useMemo } from 'react';

import { useGlobal } from 'context/Global';

const useToasts = (toastKey) => {
  const { addToast } = useGlobal();

  const success = useCallback(
    (message) =>
      addToast({
        id: toastKey,
        type: 'success',
        duration: 'short',
        message,
      }),
    [toastKey, addToast]
  );

  const error = useCallback(
    (message) =>
      addToast({
        id: toastKey,
        type: 'error',
        duration: 'long',
        message,
      }),
    [toastKey, addToast]
  );

  const info = useCallback(
    (message) =>
      addToast({
        id: toastKey,
        type: 'info',
        duration: 'short',
        message,
      }),
    [toastKey, addToast]
  );

  return useMemo(
    () => ({
      success,
      error,
      info,
    }),
    [success, error, info]
  );
};

export default useToasts;
